module.exports = __webpack_public_path__ + "img/bmu.0fdefae8.svg";